import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "react-router-dom";
export const MapLink = ({ address, children, style }) => {
    const encodedURI = encodeURIComponent(address);
    const googleMapsURL = `https://www.google.com/maps/search/?api=1&query=${encodedURI}`;
    return (_jsx(Link, { to: googleMapsURL, target: "_blank", rel: "noopener noreferrer", style: {
            fontSize: 12,
            color: "var(--mantine-color-gray-5)",
            textDecoration: "none",
            width: "fit-content",
            ...style
        }, onClick: (event) => event.stopPropagation(), children: children }));
};
